import { appName } from '@/constants';

export const setTitle = (title) => {
  title = title ? `${title} - ${appName}` : appName;
  window.document.title = title;
};
